// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1BFiU","infoBtn":"quickbooks_infoBtn__1ygdE","formBox":"quickbooks_formBox__3BGmU","formFooter":"quickbooks_formFooter__2S30w"};